<template>
  <div>
    <SettingsStatesSettingsDetail
      :entityStateId="entityStateId"
      @done="onDone"
    ></SettingsStatesSettingsDetail>
  </div>
</template>

<script>
import SettingsStatesSettingsDetail from 'CORE/components/entity-states/settings/detail'
import { get } from 'lodash'

export default {
    name: 'SettingsStatesDetailView',
    components: {
        SettingsStatesSettingsDetail,
    },
    computed: {
        entityStateId() {
            return get(this.$route.params, 'id', null)
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'settingsStatesList' })
        },
    },
}
</script>
